import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from '../../../sass/home.module.scss';
import { fetchBrandProducts } from '../../../redux/actions/brandActions';
import Slider from 'react-slick';
import ProductCard from '../../../components/ProductCard'; // Import the new ProductCard component

const BrandProducts = ({ title, brandId }) => {
    const dispatch = useDispatch();
    const products = useSelector((state) => state.brands.brandProducts[brandId]) || [];

    useEffect(() => {
        if (brandId) { dispatch(fetchBrandProducts(brandId)); }
    }, [dispatch, brandId]);

    const settings = {
        dots: false,
        speed: 500,
        draggable: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToScroll: 6,
                arrows: false,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToScroll: 4,
                arrows: false,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToScroll: 2,
                arrows: false,
              },
            },
        ],
    };

    return (
        <div className={`section__container ${styles.BrandSectionWrapper}`}>
            <div className={`section_innerWrapper`}>
                <div className={`section_title ${styles.brandSection_title}`}>{title}</div>

                {products.length === 0 ? (
                <div>No products available.</div>
                ) : (
                    <Slider {...settings} className={`${styles.slickSlider} brandProduct_slick_slider`}>
                    {products.slice(0, 10).map((product, index) => (
                        <ProductCard key={index} product={product} />
                    ))}
                    </Slider>
                )}
            </div>
        </div>
    );
};

export default BrandProducts;